import { Injectable } from '@angular/core';
import {
  PixFileSelectionCacheEntry,
  PixFileSelectionCacheKey,
  PixFileSelectionCacheService
} from '@mydocma/pix-common';

@Injectable({ providedIn: 'root' })
export class MmPixFileSelectionCacheService extends PixFileSelectionCacheService {
  private readonly cache = new Map<string, PixFileSelectionCacheEntry>();

  get(key: PixFileSelectionCacheKey): PixFileSelectionCacheEntry | null {
    const entry = this.cache.get(this.toMapKey(key));
    if (!entry) {
      return null;
    }
    return {
      files: entry.files.map(file => this.withoutSelectionState(file)),
      lastFetchTimestamp: entry.lastFetchTimestamp
    };
  }

  set(key: PixFileSelectionCacheKey, entry: PixFileSelectionCacheEntry): void {
    this.cache.set(this.toMapKey(key), {
      files: (entry.files ?? []).map(file => this.withoutSelectionState(file)),
      lastFetchTimestamp: entry.lastFetchTimestamp
    });
  }

  clear(key: PixFileSelectionCacheKey): void {
    this.cache.delete(this.toMapKey(key));
  }

  clearAll(): void {
    this.cache.clear();
  }

  private withoutSelectionState(file: any): any {
    return { ...file, isSelected: false, isCheckboxSelected: false, isFocused: false };
  }

  private toMapKey(key: PixFileSelectionCacheKey): string {
    return `${String(key.customerId)}:${String(key.projectId)}`;
  }
}
